import {Message} from './message';
import {Factory} from '../../engine/http/factory/factory';

export class MessageFactory implements Factory<Message> {
  build(o: any): Message {
    const message = new Message(o._id, o.title, o.content);
    message.icon = o.icon;
    message.type = o.type;
    message.settings = o.settings;
    message.date = o.date;
    message.isRead = o.isRead;
    message.application = o.application;
    return message;
  }

  getApi(): string {
    return '';
  }
}
